"use client";
import { createContext } from "react";
/**
 * @public
 */
export const MotionConfigContext = createContext({
    transformPagePoint: (p) => p,
    isStatic: false,
    reducedMotion: "never",
});
//# sourceMappingURL=MotionConfigContext.js.map